/**
 * Teals Design System - Shadow Tokens
 *
 * Aligned with teals-website --shadow-sm/md/lg (subtle, professional).
 */
export const shadows = {
    none: 'none',
    // From teals-website --shadow-sm
    xs: '0 1px 2px rgba(0, 0, 0, 0.04)',
    sm: '0 1px 2px rgba(0, 0, 0, 0.04)', // --shadow-sm
    // From teals-website --shadow-md
    md: '0 4px 12px rgba(0, 0, 0, 0.06)', // --shadow-md
    // From teals-website --shadow-lg
    lg: '0 8px 24px rgba(0, 0, 0, 0.08)', // --shadow-lg
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)',
};
// Focus ring - primary from teals-website --teal-primary
export const focusRings = {
    default: '0 0 0 3px rgba(45, 154, 143, 0.4)', // teal-primary
    error: '0 0 0 3px rgba(244, 67, 54, 0.4)',
    success: '0 0 0 3px rgba(76, 175, 80, 0.4)',
};
